import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';


import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBFvJMnLCpt4hVKpwVD3JgTFPftdD5KgEE",
  authDomain: "jambotree-80b12.firebaseapp.com",
  projectId: "jambotree-80b12",
  storageBucket: "jambotree-80b12.appspot.com",
  messagingSenderId: "103080051505",
  appId: "1:103080051505:web:ae04f6e301f3bde0ece610",
  measurementId: "G-96Z5L6BF5Z"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
getAnalytics(app);

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
